/* eslint-disable react/jsx-props-no-spreading,react/jsx-filename-extension */
import { Component } from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import CircularProgress from '../components/CircularProgress';
import { PageTrack } from 'containers/Services/AnalyticsProvider';

export default function asyncComponent(importComponent) {

  const getQueryParameter = (url, parameter) => {
    const queryString = new URLSearchParams(url.search);
    return queryString.get(parameter);
  };

  const getPathSegment = (url, index) => {
    return url.pathname.split('/')[index];
  };

  const getPageName = () => {
    const url = window.location;
    const tabName = getQueryParameter(url, 'tab');
    const sectionName = getQueryParameter(url, 'section');
    const appName = getPathSegment(url, 1);
    const subPageName = getPathSegment(url, 2);

    let finalPageName = appName;
    if (tabName) finalPageName += `_${tabName}`;
    if (sectionName) finalPageName += `_${sectionName}`;
    else if (!tabName && subPageName) finalPageName += `_${subPageName}`;

    return finalPageName;
  };

  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null
      };
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
      Nprogress.start();
    }

    // eslint-disable-next-line react/sort-comp
    componentWillUnmount() {
      this.mounted = false;
    }

    async componentDidMount() {
      this.mounted = true;
      // eslint-disable-next-line no-shadow
      const { default: Component } = await importComponent();

      // segment - page tracking logic
      PageTrack(getPageName());

      Nprogress.done();
      if (this.mounted) {
        this.setState({
          component: <Component {...this.props} />
        });
      }
    }

    render() {
      // eslint-disable-next-line no-shadow,react/destructuring-assignment
      const Component = this.state.component || (
        <div className="loader-view" style={{ height: 'calc(100vh - 200px)' }}>
          <CircularProgress />
        </div>
      );
      return (
        <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
          {Component}
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
